export const TOOL_TASK = 'bulk-user-import';
export const TOOL_TITLE = 'Bulk User Import';
export const FILE_NAME = 'Bulk-user-import-report';
export const FILE_HEADERS = {
    userId: 'User ID',
    email: 'Email',
    firstName: 'First Name',
    lastName: 'Last Name',
    userType: 'User Type',
    userStatus: 'User Status',
    targetAccountId: 'Target Account ID',
    targetAccountName: 'Target Account Name',
    priorAccountId: 'Prior Account ID',
    priorAccountName: 'Prior Account Name',
    country: 'Country',
    group: 'Group',
    jobTitle: 'Job Title',
    city: 'City',
    newsletters: 'Newsletters',
    notes: 'Notes',
    actionStatus: 'Action Status',
    jobInfo: 'Action Details',
};

export const TOOL_PROGRESS_LABEL = 'Bulk user importing progress...';
